import cn from 'classnames'
import {FC, useState} from 'react'

import {AffiliateBanner} from '@/components/common/banner/AffiliateBanner'
import {usePreferences} from '@/components/context/Preferences'
import {theme} from '@/theme/theme'
import {USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {PricingMultiCountryBanner} from './PricingMultiCountryBanner'

type PricingDiscountBannerProps = {
  isDiscountApplied: boolean
}

export const PricingDiscountBanner: FC<React.PropsWithChildren<PricingDiscountBannerProps>> = ({
  isDiscountApplied,
}) => {
  const {affiliate} = usePreferences()
  const [isAffiliateHidden, setIsAffiliateHidden] = useState(false)

  return (
    <>
      {affiliate ? (
        <div className={cn('banner', isAffiliateHidden && 'hidden')}>
          <AffiliateBanner
            trackedEventParameters={{position: 'Pricing'}}
            isDiscountApplied={isDiscountApplied}
            onClose={() => setIsAffiliateHidden(true)}
            hasAnimationDelay={false}
          />
        </div>
      ) : (
        <div className="banner">
          <PricingMultiCountryBanner />
        </div>
      )}

      <style jsx>{`
        .banner {
          margin-top: ${theme.spacing[4]};
        }
        .hidden {
          display: none;
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .banner {
            margin-top: 0;
            margin-bottom: ${theme.spacing[4]};
            padding-bottom: ${theme.spacing[4.5]};
            border-bottom: 1px solid ${theme.palette.gray[200]};
          }
        }
      `}</style>
    </>
  )
}
